<template>
  <div class="deal-celebration-settings">
    <FormSwitch
      :model-value="dealCelebrationEnabled"
      :label="$t('PROFILE_SETTINGS.FORM.DEAL_CELEBRATION.LABEL')"
      :description="$t('PROFILE_SETTINGS.FORM.DEAL_CELEBRATION.DESCRIPTION')"
      :disabled="isUpdating"
      @update:modelValue="updateDealCelebration"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import FormSwitch from 'v3/components/Form/Switch.vue';

export default {
  name: 'DealCelebrationPreferences',
  components: {
    FormSwitch,
  },
  data() {
    return {
      isUpdating: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    dealCelebrationEnabled() {
      // Asegurarse de que el valor sea booleano y maneje null/undefined
      const value = this.currentUser?.deal_celebration_enabled;
      return value === true || value === false ? value : true;
    },
  },
  methods: {
    async updateDealCelebration(value) {
      if (this.isUpdating) return;
      
      this.isUpdating = true;
      
      try {
        await this.$store.dispatch('updateProfile', {
          deal_celebration_enabled: value,
        });
        
        useAlert(this.$t('PROFILE_SETTINGS.FORM.DEAL_CELEBRATION.SUCCESS'));
      } catch (error) {
        useAlert(this.$t('PROFILE_SETTINGS.FORM.DEAL_CELEBRATION.ERROR'));
      } finally {
        this.isUpdating = false;
      }
    },
  },
};
</script>

<style scoped>
.deal-celebration-settings {
  margin-bottom: 1rem;
}
</style>